import { render, staticRenderFns } from "./PrivacyGuidePhishing.vue?vue&type=template&id=25f78860&scoped=true"
import script from "./PrivacyGuidePhishing.vue?vue&type=script&lang=js"
export * from "./PrivacyGuidePhishing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25f78860",
  null
  
)

export default component.exports